import React from 'react';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { Translate, TranslateScope } from '@pegasus/translation';
import { SkipLinkWrapper } from './styles';
export const SkipLink = () => (React.createElement(TranslateScope, null,
    React.createElement(SkipLinkWrapper, null,
        React.createElement(Button, { buttonType: ButtonType.tertiary, color: ButtonColor.dark, link: true, href: "#main" },
            React.createElement(Translate, { message: "skipToMain" })))));
//# sourceMappingURL=index.js.map